import { Spinner } from '@/_components';

export function InvoiceGenerating({ label }: { label: string }) {
  return (
    <div
      className="text-c-card-muted flex items-center gap-2 self-start rounded-full bg-black/10 px-3.5 py-1.5 text-sm font-medium sm:self-auto"
      data-id="element-8"
    >
      <Spinner size="xs" />
      <span className="text-c-card-muted">{label}</span>
    </div>
  );
}
